export default "__VITE_ASSET__aa9e4623__"